import { FC } from 'react';

import { useGetRelationship } from 'app/api/hooks/core/v1/payee/payeeRelationships';
import { useBoolean } from 'app/components/v2/hooks';

import HeldInvoiceDialog from '.';

// Local Typings
interface Props {
  payeeRelationshipId: string;
  payorName: string;
  statusNote: string;
}

// Component Definition
const HeldInvoicePayeeDialog: FC<Props> = props => {
  const {
    handleSetTrue: handleOnOpen,
    isTrue: isOpen,
  } = useBoolean(false);

  const { data, isLoading } = useGetRelationship(props.payeeRelationshipId,
    { enabled: isOpen });

  const payeeRelationship = data?.payeeRelationship;

  return (
    <HeldInvoiceDialog
      isLoading={isLoading}
      onOpen={handleOnOpen}
      relationshipName={props.payorName}
      relationshipPhoneNumber={payeeRelationship?.payor.phoneNumber}
      relationshipPrimaryEmail={payeeRelationship ? payeeRelationship.payor.primaryEmail : undefined}
      statusNote={props.statusNote}
    />
  );
};

export default HeldInvoicePayeeDialog;
